import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./login.css";

function ForgotPassword() {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [step, setStep] = useState(1);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);

  const API_URL = "https://dashboard.jyotirvani.com";

  const parseResponse = async (res) => {
    const text = await res.text();

    try {
      return JSON.parse(text);
    } catch {
      throw new Error("Backend returned HTML, not JSON. Check Laravel route.");
    }
  };

  const sendOtp = async (e) => {
    e.preventDefault();

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!email.trim()) {
      setError("Email is required");
      return;
    }

    if (!emailRegex.test(email)) {
      setError("Enter a valid email");
      return;
    }

    try {
      setLoading(true);
      setError("");
      setSuccess("");

      const res = await fetch(`${API_URL}/forgot-password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ email }),
      });

      const data = await parseResponse(res);

      if (!res.ok || data.status === false) {
        setError(data?.message || "Email not found");
        return;
      }

      setSuccess(data?.message || "OTP sent to your email.");
      setStep(2);
    } catch (err) {
      console.error("FORGOT PASSWORD ERROR:", err);
      setError(err.message || "Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const resetPassword = async (e) => {
    e.preventDefault();

    const passwordRegex = /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&]).{8,}$/;

    if (!otp.trim()) {
      setError("OTP is required");
      return;
    }

    if (!passwordRegex.test(password)) {
      setError(
        "Password must be 8+ characters with 1 uppercase, 1 number and 1 special character."
      );
      return;
    }

    if (password !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    try {
      setLoading(true);
      setError("");
      setSuccess("");

      const res = await fetch(`${API_URL}/reset-password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          email,
          otp,
          password,
        }),
      });

      const data = await parseResponse(res);

      if (!res.ok || data.status === false) {
        setError(data?.message || "Password reset failed");
        return;
      }

      navigate("/login", {
        state: {
          message: "Password reset successful. Please login.",
        },
      });
    } catch (err) {
      console.error("RESET PASSWORD ERROR:", err);
      setError(err.message || "Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-overlay">
        <div className="login-card forgot-card">
          <div className="login-left forgot-left">
            <h1>{step === 1 ? "Forgot Password?" : "Verify OTP"}</h1>
            <p>
              {step === 1
                ? "Enter your registered email address. We will send an OTP to reset your password."
                : "Enter the OTP sent to your email and create a new secure password."}
            </p>
          </div>

          <div className="login-right">
            <h2>{step === 1 ? "Reset Password" : "Create New Password"}</h2>
            <p className="login-subtitle">
              {step === 1 ? "Enter your email to continue" : email}
            </p>

            {step === 1 ? (
              <form onSubmit={sendOtp} className="login-form">
                <div className="login-field">
                  <label>Email Address</label>
                  <input
                    type="email"
                    placeholder="Enter registered email"
                    value={email}
                    onChange={(e) => {
                      setEmail(e.target.value);
                      setError("");
                      setSuccess("");
                    }}
                  />
                </div>

                {error && <p className="login-error">{error}</p>}
                {success && <p className="login-success">{success}</p>}

                <button type="submit" className="login-btn" disabled={loading}>
                  {loading ? "Sending..." : "Send OTP"}
                </button>
              </form>
            ) : (
              <form onSubmit={resetPassword} className="login-form">
                <div className="login-field">
                  <label>OTP</label>
                  <input
                    type="text"
                    placeholder="Enter OTP"
                    value={otp}
                    onChange={(e) => {
                      setOtp(e.target.value.replace(/\D/g, "").slice(0, 6));
                      setError("");
                    }}
                  />
                </div>

                <div className="login-field">
                  <label>New Password</label>
                  <input
                    type="password"
                    placeholder="New password"
                    value={password}
                    onChange={(e) => {
                      setPassword(e.target.value);
                      setError("");
                    }}
                  />
                  <p className="password-hint">
                    • Minimum 8 characters <br />
                    • 1 uppercase letter <br />
                    • 1 number & 1 special character
                  </p>
                </div>

                <div className="login-field">
                  <label>Confirm Password</label>
                  <input
                    type="password"
                    placeholder="Confirm password"
                    value={confirmPassword}
                    onChange={(e) => {
                      setConfirmPassword(e.target.value);
                      setError("");
                    }}
                  />
                </div>

                {error && <p className="login-error">{error}</p>}
                {success && <p className="login-success">{success}</p>}

                <button type="submit" className="login-btn" disabled={loading}>
                  {loading ? "Updating..." : "Reset Password"}
                </button>
              </form>
            )}

            <div className="register-link">
              <p>
                Remember password?{" "}
                <a
                  href="/login"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("/login");
                  }}
                >
                  Back to Login
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;